import { IconButton } from '@mui/material'
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined'
import { useOptionsPopover } from '@/core/popover/popover-hooks'
import { DefaultPopover } from '@/core/popover/DefaultPopover'
import { ColumnsPopover } from './ColumnsPopover'
import { useCollectionViewContext } from '@/objects/collection-view/top-bar/CollectionViewPageContext.ts'
import { useTutorialTarget } from '@/tutorial/TutorialContext'

export function ColumnsButton() {
  const { viewSettings } = useCollectionViewContext()
  const popover = useOptionsPopover()
  const tutorialTargetRef = useTutorialTarget('collection-columns-button')

  return (
    <>
      <IconButton
        ref={tutorialTargetRef}
        disabled={!viewSettings}
        size="small"
        onClick={(e) => popover.openPopover(e.currentTarget)}
      >
        <ViewWeekOutlinedIcon fontSize="medium" />
      </IconButton>
      <DefaultPopover anchorEl={popover.anchorEl} close={popover.closePopover}>
        <ColumnsPopover />
      </DefaultPopover>
    </>
  )
}
